import createVueComponent from '../createVueComponent';
var Moon = createVueComponent('MoonIcon', [['path', {
  d: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z',
  key: '1lhmh3'
}]]);
export default Moon;